import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../common/html/checkbox'
import { Element } from '../../common/html/element'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../helpers/EventEmitter'
import { selectUserType } from '../../layout/store/slice'
import {
  checkAll,
  selectBusinessCreditReportId,
  selectCheck,
  selectFactSheetId,
  uncheckAll,
} from '../store/slice'
import { delCartItem, getCartItems } from '../store/thunk'
import { DeleteItems } from './poupAction/DeleteItems'

const CheckAll = () => {
  const dispatch = useDispatch()

  const [isShowDelete, setShowDelete] = useState(false)

  const factSheetId = useSelector(selectFactSheetId)
  const businessCreditReportId = useSelector(selectBusinessCreditReportId)
  const userType = useSelector(selectUserType)
  const check = useSelector(selectCheck)
  const lengthChecked = Object.keys(check).length

  const isCheckAll = useMemo(
    () => factSheetId.concat(businessCreditReportId).every((id) => check[id]),
    [lengthChecked],
  )

  const onChange = (isCheck) => {
    if (isCheck) {
      dispatch(checkAll())
    } else {
      dispatch(uncheckAll())
    }
  }

  const selectAll = () => {
    if (isCheckAll) {
      dispatch(uncheckAll())
    } else {
      dispatch(checkAll())
    }
  }

  const deleteAllCartItem = () => {
    dispatch(
      delCartItem({
        cartItemIds: [...Object.keys(check)],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(uncheckAll())
        dispatch(getCartItems({ userType: userType.userTypeId }))
        handleClose()
      })
      .catch(() => {})
  }

  const openDelete = () => {
    if (!lengthChecked) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [<Translate value="cartAndOrders.message.m16" />],
      })
      return
    }
    setShowDelete(true)
  }

  const handleClose = () => {
    setShowDelete(false)
  }
  const handleSubmit = () => {
    deleteAllCartItem()
  }

  return (
    <>
      <div className="w30 dFlex alignItemsEnd" style={{ paddingBottom: 36 }}>
        <Checkbox
          onChange={onChange}
          checked={
            isCheckAll ? isCheckAll : lengthChecked && !isCheckAll ? -1 : false
          }
          styleIcon={{ fontSize: 16 }}
        />
        <Element
          elementName="span"
          className="ml4 cursorPointer"
          style={{ color: '#2C73E8' }}
          onClick={selectAll}
        >
          <Translate value="cartAndOrders.main.selectAll" /> (
          {factSheetId.concat(businessCreditReportId).length})
        </Element>
        <Element
          elementName="span"
          className="ml4 cursorPointer"
          style={{ color: '#2C73E8' }}
          onClick={openDelete}
        >
          <Translate value="cartAndOrders.main.delete" />
        </Element>
      </div>
      {isShowDelete && (
        <DeleteItems
          isShow={isShowDelete}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          count={lengthChecked}
        />
      )}
    </>
  )
}

export default CheckAll
